"use client";
import { PageLayout } from "@/components/page-layout";
import { useLangRouter } from "@/utils/use-lang-router";
import { Heading, Text } from "@chakra-ui/react";
import Link from "next/link";
import { useEffect } from "react";

export default function NotFound() {
  const { prependLang, lang, detectedLang } = useLangRouter();

  useEffect(() => {
    prependLang();
  }, [prependLang]);

  return (
    <PageLayout>
      {detectedLang ? (
        <>
          <Heading>Not Found</Heading>
          <Text>The page you are looking for does not exist.</Text>
          <Link href={`/${lang}`}>Go back to the home page</Link>
        </>
      ) : (
        <Heading>Redirecting</Heading>
      )}
    </PageLayout>
  );
}
